import { Trash2 } from "lucide-react";
import { useFormContext, useWatch } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { ControlledUnifiedInput } from "@/components/ui/customs/controlled-unified-input";
import {
  FREIGHT_WEIGHT_THRESHOLD_KG,
  QuotationUpdateBoFormData,
} from "@/types/forms/bo/expeditionBo.form";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const FedexApiPackageItem = ({
  index,
  remove,
}: {
  index: number;
  remove: (index: number) => void;
}) => {
  const { t } = useTranslation("boExpeditionForm");
  const methods = useFormContext<QuotationUpdateBoFormData>();

  const weightWatch = useWatch({
    control: methods.control,
    name: `expeditionFedexApi.expeditionPackaging.${index}.weight`,
  });

  const insuranceOption = useWatch({
    control: methods.control,
    name: `options.insurance`,
  });

  useEffect(() => {
    if (!insuranceOption) {
      methods.setValue(`expeditionFedexApi.expeditionPackaging.${index}.value`, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insuranceOption]);

  return (
    <div className="grid grid-cols-2 items-start gap-2 rounded-lg bg-slate-200 p-4 @xl:grid-cols-4 @3xl:flex @3xl:flex-row">
      <ControlledUnifiedInput
        label={t("fedexPackageItem.countLabel")}
        required
        control={methods.control}
        name={`expeditionFedexApi.expeditionPackaging.${index}.count`}
        inputType="integer"
        className="w-full"
        wrapperClassName="w-full"
      />
      <ControlledUnifiedInput
        label={t("fedexPackageItem.weightLabel")}
        required
        control={methods.control}
        name={`expeditionFedexApi.expeditionPackaging.${index}.weight`}
        inputType="float"
        className="w-full"
        wrapperClassName="w-full"
      />
      <ControlledUnifiedInput
        label={t("fedexPackageItem.lengthLabel")}
        required={weightWatch > FREIGHT_WEIGHT_THRESHOLD_KG}
        control={methods.control}
        name={`expeditionFedexApi.expeditionPackaging.${index}.length`}
        inputType="integer"
        className="w-full"
        wrapperClassName="w-full"
      />
      <ControlledUnifiedInput
        label={t("fedexPackageItem.widthLabel")}
        required={weightWatch > FREIGHT_WEIGHT_THRESHOLD_KG}
        control={methods.control}
        name={`expeditionFedexApi.expeditionPackaging.${index}.width`}
        inputType="integer"
        className="w-full"
        wrapperClassName="w-full"
      />
      <ControlledUnifiedInput
        label={t("fedexPackageItem.heightLabel")}
        required={weightWatch > FREIGHT_WEIGHT_THRESHOLD_KG}
        control={methods.control}
        name={`expeditionFedexApi.expeditionPackaging.${index}.height`}
        inputType="integer"
        className="w-full"
        wrapperClassName="w-full"
      />
      {insuranceOption && (
        <ControlledUnifiedInput
          label={t("fedexPackageItem.insuranceLabel")}
          required
          control={methods.control}
          name={`expeditionFedexApi.expeditionPackaging.${index}.value`}
          inputType="float"
          className="w-full"
          wrapperClassName="w-full"
          subWrapperClassName="!border-2 !border-blue-800"
        />
      )}
      <Button
        type="button"
        onClick={() => remove(index)}
        variant="ghost"
        className="h-fit w-fit sm:mt-2 [&_svg]:h-6 [&_svg]:w-6"
      >
        <Trash2 className="h-6 w-6 text-red-600" />
      </Button>
    </div>
  );
};
